<template>
	<OnboardingStep
		:commit="commit"
		:disable-next="itemCount < minItemCount || itemCount > maxItemCount"
		:error="error"
		:form-id="formId"
		v-slot="{ next }"
	>
    
		<h1 class="onboarding-step-heading">Here's a sample of my work...</h1>

		<div class="card-v2">
			<EditPortfolioForm
				:confirm-discard="false"
				:id="formId"
				live-changes
				:verb="null"
				@save="next"
			/>
		</div>
	</OnboardingStep>
</template>

<script>
import EditPortfolioForm from '@/components/forms/EditPortfolioForm';
import { settings } from '@/helpers/portfolio';
import onboarding from '@/mixins/onboarding';

export default {
  name: 'OnboardingPortfolio',
  mixins: [onboarding],
  components: { EditPortfolioForm },
  onboardingStep: {
    isApplicable: ({ plan }) => plan && plan.canUsePortfolio,
    isCompleted: ({ profile }) => {
      const count = profile?.portfolios.length;
      return count != null && count >= settings.minItemCount && count <= settings.maxItemCount;
    },
    requires: ({ profile }) => profile,
  },
  computed: {
    /**
     * @returns {string | null | undefined}
     */
    error() {
      const { itemCount: count, maxItemCount: max, minItemCount: min } = this;
      return count < min
        ? `Please upload at least ${min} item${min === 1 ? '' : 's'} to continue.`
        : count > max
        ? `Please remove ${count - max} item${count - max === 1 ? '' : 's'} to continue.`
        : null;
    },
    /**
     * @returns {string}
     */
    formId() {
      return 'onboarding-step-form';
    },
    /**
     * @returns {number}
     */
    itemCount() {
      return this.portfolio.length;
    },
    /**
     * @returns {number}
     */
    maxItemCount() {
      return settings.maxItemCount;
    },
    /**
     * @returns {number}
     */
    minItemCount() {
      return settings.minItemCount;
    },
    /**
     * @returns {Portfolio}
     */
    portfolio() {
      return this.profile.portfolios;
    },
    showUploadProgressWidget: {
      /**
       * @returns {boolean | null}
       */
      get() {
        return this.$store.getters['portfolios/showProgressWidget'];
      },
      /**
       * @param {boolean | null} value
       * @returns {void}
       */
      set(value) {
        this.$store.commit('portfolios/setShowProgressWidget', value);
      },
    },
  },
  methods: {
    /**
     * @returns {void}
     */
    commit() {
      if (this.showUploadProgressWidget == null) {
        /**
         * Show the portfolio upload progress widget if it hasn't already been explicitly hidden for
         * the current upload
         */
        this.showUploadProgressWidget = true;
      }
    },
  },
};
</script>
